const eventHandlers = {
    animationEnd: function (chartContext, options) {},
    beforeMount: function (chartContext, config) {},
    mounted: function (chartContext, config) {},
    updated: function (chartContext, config) {},
    mouseMove: function (event, chartContext, config) {},
    mouseLeave: function (event, chartContext, config) {},
    click: function (event, chartContext, config) {},
    legendClick: function (event, chartContext, config) {},
    markerClick: function (event, chartContext, { seriesIndex, dataPointIndex, config }) {},
    xAxisLabelClick: function (event, chartContext, config) {},
    selection: function (chartContext, { xaxis, yaxis }) {},
    dataPointSelection: function (event, chartContext, config) {},
    dataPointMouseEnter: function (event, chartContext, config) {},
    dataPointMouseLeave: function (event, chartContext, config) {},
    beforeZoom: function (chartContext, { xaxis }) {},
    beforeResetZoom: function (chartContext, opts) {},
    zoomed: function (chartContext, { xaxis, yaxis }) {},
    scrolled: function (chartContext, { xaxis }) {},
    brushScrolled: function (chartContext, { xaxis, yaxis }) {}
}

export const eventNames = Object.keys(eventHandlers)

export default eventHandlers
